import { render } from "./App.vue?vue&type=template&id=20490ccf"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=20490ccf&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/user_center_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__